/**
 * Returns Tailwind badge classes for a payout status.
 */
export const getPayoutStatusBadge = (status) => {
  switch (status) {
    case "pending":
      return "bg-yellow-500 text-white";
    case "processing":
      return "bg-blue-500 text-white";
    case "completed":
      return "bg-green-500 text-white";
    case "failed":
      return "bg-red-500 text-white";
    case "cancelled":
      return "bg-gray-500 text-white";
    default:
      return "bg-gray-400 text-white";
  }
};

/**
 * Format a number as SAR currency.
 */
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return "SAR 0.00";
  return `SAR ${Number(amount).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

/**
 * Format a date string to a readable short date.
 */
export const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  return new Date(dateStr).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};
